import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SalonManagementCreateMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.salon.manage.create(0));
  };

  return (
    <MainMenuItem
      itemTitleString="美容室を登録する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SalonManagementCreateMenuItem;
